// TODO: change wasteWaterFacility variables to facility
export const wastewaterFacilitiesReducerName = "wastewaterFacilities";
